export enum SubscriptionStatusEnum {
  Trialing = 'trialing',
  Active = 'active',
  Cancel = 'cancel',
  Uninitialized = 'uninitialized',
}
